































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class ImgFooter extends Vue {
  year = new Date().getFullYear();
}
